import { render } from "./PendingTopUp.vue?vue&type=template&id=6615ddf0&scoped=true&ts=true"
import script from "./PendingTopUp.vue?vue&type=script&lang=ts"
export * from "./PendingTopUp.vue?vue&type=script&lang=ts"

import "./PendingTopUp.vue?vue&type=style&index=0&id=6615ddf0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6615ddf0"]])

export default __exports__